<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button data-test="menuButton" auto-hide="false"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title">Activities</ion-title>
    </ion-toolbar>
</ion-header>
    
<ion-content class="ion-padding">
    Display activities here
</ion-content>